var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.language.getLanguage(),attrs:{"id":"app"}},[_c('router-view',{attrs:{"isReady":_setup.isReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }